import { ComponentProps, memo, MouseEvent } from 'react'
import IconModalClose from 'assets/modal-close.svg?react'
import cn from 'classnames'
import { ButtonIcon } from 'components/extend/ButtonIcon'

import s from './CloseButton.module.less'

interface IProps extends ComponentProps<'div'> {
  onClick?: (event: MouseEvent) => void
}

export const CloseButton = memo<IProps>(function CloseButton({ className, onClick, ...rest }) {
  return (
    <div {...rest} className={cn(s.CloseButton, className)}>
      <ButtonIcon color="gray" data-test-id="modal-close-button" icon={IconModalClose} onClick={onClick} />
    </div>
  )
})
